import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common'; // Often needed for async pipe, *ngIf
import { ActivatedRoute, NavigationEnd, Router, RouterModule, Event } from '@angular/router'; // For router-outlet
import { MatSidenavModule } from '@angular/material/sidenav';
import { AuthService } from './services/auth.service';
import { Observable } from 'rxjs';
import { User } from './models/userModel';
import { map ,filter, startWith } from 'rxjs/operators';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component'; 
import { KeycloakAuthService } from '../app/services/keycloak-auth.service';

@Component({
  selector: 'app-root',
  standalone: true, 
  imports: [
      CommonModule,
      RouterModule,    
      MatSidenavModule,
      HeaderComponent,  
      SidebarComponent  
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  authService = inject(KeycloakAuthService);
  router = inject(Router);
  activatedRoute = inject(ActivatedRoute);

  currentUser$: Observable<User | null> = this.authService.currentUser$;
  isLoggedIn$: Observable<boolean> = this.currentUser$.pipe(map(user => !!user));
  showLayout$!: Observable<boolean>;
  isSidebarExpanded = true;

  ngOnInit(): void {
    this.showLayout$ = this.router.events.pipe(
      // Ensure filter is recognized from the import above
      // The type predicate 'event is NavigationEnd' should now work correctly
      filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd),
      map(() => {
        let route = this.activatedRoute;
        while (route.firstChild) {
          route = route.firstChild;
        }
        return !(route.snapshot.data['hideLayout'] === true);
      }),
      // Ensure startWith is recognized from the import above
      startWith(this.shouldShowLayoutInitially())
    );
  }

  private shouldShowLayoutInitially(): boolean {
     let route = this.activatedRoute;
      while (route.firstChild) {
        route = route.firstChild;
      }
      return !(route.snapshot.data['hideLayout'] === true);
  }

  toggleSidebar(): void {
    this.isSidebarExpanded = !this.isSidebarExpanded;
  }
}